import { gql } from '@apollo/client'

import { PHOTO_DETAIL_FIELDS } from '../fragments/photoDetail.gql'

export const GET_QUESTIONS_DETAIL_BY_FILTER = gql`
    query questionsDetailByFilter($questionFilterInput: QuestionFilterInput) {
        questionsGet(questionFilterInput: $questionFilterInput) {
            isSuccess
            code
            errorMessage
            data {
                id
                questionBankId
                level
                questionGroupId

                isFlaged
                inputType
                chapter {
                    id
                    name
                }
                questionGroup {
                    id
                    name
                }
                questionTypeId
                questionType {
                    id
                    name
                }
                conceptCards {
                    id
                    name
                }
                content {
                    inputType
                    ... on MCContent {
                        body
                        answers {
                            id
                            body
                        }
                        correctAnswerIds
                        solution
                    }
                    ... on ShortQuestionContent {
                        body
                        answer
                        solution
                    }
                }
                tags {
                    id
                    name
                }
                photoAttachments {
                    ...photoDetail
                }
                createAt
                updateAt
            }
        }
    }

    ${PHOTO_DETAIL_FIELDS}
`
